import yrdBadge from "@/assets/yrd-badge.svg";
import { GradualSpacing } from "@/components/ui/gradual-spacing";
import { motion } from "framer-motion";
import { useRef } from "react";
import { useMobileOnceInView } from "@/hooks/use-mobile-once-in-view";

const IntroSection = () => {
  const sectionRef = useRef(null);
  const isInView = useMobileOnceInView(sectionRef, { margin: "-50px" });

  return (
    <section ref={sectionRef} className="relative min-h-[80vh] flex items-center justify-center bg-yacht-cream overflow-hidden">
      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto text-center px-6 py-24">
        {/* Logo badge - animated */}
        <motion.div 
          className="inline-flex items-center justify-center mb-12"
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          <img 
            src={yrdBadge} 
            alt="Yacht Rock Detroit" 
            className="w-24 h-24 object-contain"
          />
        </motion.div>

        {/* Statement text - serif with animated text, second line on its own */}
        <div 
          className="text-2xl sm:text-3xl md:text-4xl text-yacht-charcoal leading-relaxed mb-12"
          style={{ fontFamily: 'Georgia, Times New Roman, serif' }}
        >
          <div className="mb-2">
            <GradualSpacing 
              text="This is what summer is supposed to feel like."
              duration={0.4}
              delayMultiple={0.03}
            />
          </div>
          <div className="italic text-yacht-charcoal/70">
            <GradualSpacing
              text="Same river, next summer — see you in 2027."
              duration={0.4}
              delayMultiple={0.03}
            />
          </div>
        </div>

        {/* Early access button - outlined, rounded, animated */}
        <motion.button
          onClick={() => window.dispatchEvent(new Event('openEarlyAccess'))}
          className="inline-flex items-center justify-center px-10 py-3 border border-yacht-blue rounded-full text-yacht-blue font-medium hover:bg-yacht-blue hover:text-white transition-all duration-300"
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.6, delay: 0.6, ease: "easeOut" }}
        >
          Get 2027 Early Access
        </motion.button>
      </div>
    </section>
  );
};

export default IntroSection;
